import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import * as SmartAppActions from './smart-app.actions';
import { SmartAppService } from '../../core/services/smart-app.service';
import { SmartApp } from '../../core/models/smart-app.model';

@Injectable()
export class SmartAppEffects {
  constructor(
    private actions$: Actions,
    private smartAppService: SmartAppService
  ) {}

  getSmartApps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SmartAppActions.getSmartApps),
      concatMap(() =>
        this.smartAppService.getSmartApps().pipe(
          map((smartApps: SmartApp[]) =>
            SmartAppActions.getSmartAppsSuccess({ smartApps })
          ),
          catchError((error) =>
            of(SmartAppActions.getSmartAppsFailure({ error }))
          )
        )
      )
    )
  );
}
